import * as React from 'react'
import { Box } from "@mui/material"
import { ImageSeeker } from "@ui-seeker/core"


export default function imageSkuColumn() {
    return {
        name: 'skuID', label: 'Product Image',
        options: {
            headerAlign: 'center',
            setCellProps: () => ({ sx: { minWidth: '150px' }}),
            customBodyRowRenderLite: value => <Box sx={{
                position: 'relative',
                overflow: 'hidden',
                width: 100, height: 100,
                border: '2px solid',
                borderColor: "divider",
                margin: "0 auto"
            }}>
                <ImageSeeker
                    src={`/api/master-data/sku/image/${value}`}
                    sx={{ width: 1, height: 1 }}
                />
            </Box>
        }
    }
}